import React from 'react';
import ReactDOM from 'react-dom';
import thunk from 'redux-thunk';

import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { Provider } from 'react-redux';

import FormEditorComponent from './components/form-editor/';

import typesReducer from './shared/store/reducers/types';

import permissionReducer from './shared/store/reducers/permission';

import sharedReducer from './shared/store/reducers/shared';

import notesReducer from './components/notes/store/reducers/notes';
import notesTypesReducer from './components/notes/store/reducers/types';

import filesReducer from './components/ncFileManager/store/reducers/files';
import sendFilesReducer from './components/ncFileManager/store/reducers/send-files';

import phoneBookReducer from './components/ncFileManager/store/reducers/phone-book';

import formEditorReducer from './components/form-editor/store/reducers';

import signatureReducer from './components/signature/store/reducers/signature';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
  types: typesReducer,
  permissions: permissionReducer,
  shared: sharedReducer,

  notes: notesReducer,
  notesTypes: notesTypesReducer,

  sendFiles: sendFilesReducer,

  files: filesReducer,

  phoneBook: phoneBookReducer,

  formEditor: formEditorReducer,

  signature: signatureReducer,
});

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

const formEditorRoot = document.getElementById('form-editor-root');

if (formEditorRoot) {
  const app = (
    <Provider store={store}>
      <FormEditorComponent rootContainer={() => formEditorRoot} />
    </Provider>
  );

  ReactDOM.render(app, formEditorRoot);
}
